import { Language } from '@axo/config/@types/Language.types';
import React, { lazy, Suspense, useMemo } from 'react';

import styles from './BankIDButton.module.scss';
import { BankIDButtonProps } from './BankIDButton.types';

type LabelSvgMap = {
  [key in NonNullable<BankIDNOButtonProps['action']>]: {
    [key in NonNullable<BankIDNOButtonProps['language']>]: () => ReturnType<
      typeof lazy
    >;
  };
};

const createLabelSvgMap = (): LabelSvgMap => ({
  login: {
    en: () => lazy(() => import('./@assets/login-with-bankid-no.en.svg?react')),
    nb: () => lazy(() => import('./@assets/login-with-bankid-no.nb.svg?react')),
  },
  continue: {
    en: () =>
      lazy(() => import('./@assets/continue-with-bankid-no.en.svg?react')),
    nb: () =>
      lazy(() => import('./@assets/continue-with-bankid-no.nb.svg?react')),
  },
});

const labelSvgMap = createLabelSvgMap();

export type BankIDNOButtonProps = BankIDButtonProps & {
  language?: Extract<Language, 'en' | 'nb'>;
};

export const BankIDNOButton = ({
  action = 'continue',
  language = 'nb',
  href,
  ...props
}: BankIDNOButtonProps) => {
  const LazyLabelSvg = labelSvgMap[action]?.[language];

  const LabelSvg = useMemo(
    () => LazyLabelSvg && LazyLabelSvg(),
    [LazyLabelSvg]
  );

  if (!LazyLabelSvg) {
    console.error(
      `Invalid action or language provided: action=${action}, language=${language}`
    );
    return null;
  }

  const Element = href ? 'a' : 'button';

  return (
    <Element
      {...(Element === 'button'
        ? { type: 'button' }
        : { href, target: '_self', rel: 'noreferrer' })}
      className={styles.bankIDNOButton}
      {...props}
    >
      <span className={styles.label}>
        <Suspense>
          <LabelSvg />
        </Suspense>
      </span>
    </Element>
  );
};
